import React, { Component, useState, useEffect } from "react";
import styled from "styled-components";
import { Ptag } from ".";
import { useNavigate } from "react-router-dom";
import logout from "../../assets/images/logout.png";
import { logoutHandler } from "utlis/utils";
import { theme } from "theme";
import { Button } from "@mui/material";
import http from "services/httpService";

const HeaderDas = (props) => {
  let navigate = useNavigate();
  const permission = localStorage.getItem("permission");
  const [localPremission, setPremission] = useState(true);
  const is_approved = JSON.parse(localStorage.getItem("is_approved"));
  const activePlan = async () => {
    try {
      const { data } = await http.post("/business/activate_company/");
      localStorage.setItem("is_approved", true);
      setPremission(false);
    } catch (e) {
      console.log(e);
    }
  };
  console.log(props);
  return (
    <HomeWrapper>
      <MainDiv>
        {props && props.company_name && (
          <WelcomeLeft>
            <Ptag
              fontSize="32px"
              fontFamily="Merriweather"
              fontWeight="600"
              letterSpacing="0.6px"
              marginBottom="1rem"
              letterHeight="1.13"
            >
              {props.company_name && props.company_name}
            </Ptag>
            {/* <Ptag marginTop="14px" fontSize="14px" letterSpacing="0.58px">
              Welcome to Neo Insurance Broking
            </Ptag> */}
            {/* <Ptag fontSize='15px' fontWeight='normal' marginTop='12px' letterSpacing='0.58px' color='#4a4a4a'>welcome to vital</Ptag> */}
          </WelcomeLeft>
        )}
        {permission == "APPROVE" && !is_approved && localPremission && (
          <Mainbuttonwrapper>
            <Button
              onClick={() => activePlan()}
              variant="contained"
              // color="success"
              style={{
                width: "192px",
                height: "48px",
                borderRadius: "8px",
                fontSize: "16px",
                backgroundColor: "#7EFA8340",
                border: " 1px solid #08AD3699",
                color: "#027A48",
                boxShadow: "none",
                textTransform: "capitalize",
              }}
            >
              Activate Account
            </Button>
          </Mainbuttonwrapper>
        )}
      </MainDiv>
    </HomeWrapper>
  );
};

export default HeaderDas;

const HomeWrapper = styled.div`
  margin-left: 248px;
  transition: margin-left 0.2s ease-in;
  padding: 40px 40px 18px 40px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: white;
  margin-bottom: 12px;
  box-shadow: rgb(0 0 0 / 15%) 0px 1px 4px 0px;
`;

const MainDiv = styled.div`
  display: flex;
  text-align: left;
  line-height: 1.5;
  letter-spacing: 0.5px;
  color: #436ab2;
  justify-content: space-between;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
`;

const WelcomeLeft = styled.div`
  font-style: normal;
  font-stretch: normal;
  line-height: 1.13;
  letter-spacing: 0.6px;
  color: #436ab2;
`;
const Mainbuttonwrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const RewardsRight = styled.div`
  display: flex;

  cursor: pointer;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.13;
  letter-spacing: 0.6px;
  color: #436ab2;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 12px 16px;

  box-shadow: rgb(0 0 0 / 15%) 0px 1px 4px 0px;
  border-radius: 5px;
  border: none;
`;
